import { render } from "./AccountModalResetPassword.vue?vue&type=template&id=401f3eab"
import script from "./AccountModalResetPassword.vue?vue&type=script&lang=js"
export * from "./AccountModalResetPassword.vue?vue&type=script&lang=js"
script.render = render

export default script